import {
  applicationStatusRequest,
  applicationStatusRequestSuccess,
  applicationStatusRequestFailure,
} from './actions';

import { fetch } from '../../utils/httpUtil';
import { getLocalStorage, setLocalStorage } from '../../utils/storageUtil';
import {
  USER_ID,
  REGISTRATION_STATUS,
  APPLICATION_STATUS,
} from '../../constants/config';

export const fetchApplicationStatus = () => {
  return (dispatch) => {
    dispatch(applicationStatusRequest());

    return fetch(`client/v1/applicants/${getLocalStorage(USER_ID)}/status`)
      .then((response) => {
        if (response.data.message === 'SUCCESS') {
          setLocalStorage(
            REGISTRATION_STATUS,
            response.data.data.sectionStatus
          );
          setLocalStorage(APPLICATION_STATUS, response.data.data.status_code);
          dispatch(applicationStatusRequestSuccess(response.data.data));
        } else {
          // TODO
        }
        return response;
      })
      .catch((error) =>
        dispatch(applicationStatusRequestFailure(error.response.data))
      );
  };
};
